import React from 'react';
import { Col } from 'react-bootstrap';

import CentralizedSpinner from 'components/CentralizedSpinner';
import useAreaReference from 'hooks/Meteorology/Weather/Area/References/useAreaReferences';
import useIsMobile from 'utils/hooks/useIsMobile';

import './index.scss';

export default function References({
  areaAcronym,
  areaLabel,
}: {
  areaAcronym: string;
  areaLabel: string;
}) {
  const isMobile = useIsMobile();
  const { pdfUrl, isLoading } = useAreaReference({ area: areaAcronym });

  if (isLoading) {
    return <CentralizedSpinner />;
  }

  if (isMobile) {
    return (
      <div className="weather-reference-mobile">
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="weather-reference-open"
        >
          Abrir documento em nova aba
        </a>
        <object
          title={`${areaLabel} reference`}
          data={pdfUrl}
          className="weather-reference-pdf-mobile"
        />
      </div>
    );
  }

  return (
    <Col className="p-4">
      <object
        title={`${areaLabel} reference`}
        data={pdfUrl}
        className="weather-reference-pdf"
      />
    </Col>
  );
}
